









































import nav from '@/_nav'
import { Component, Vue } from 'vue-property-decorator'
import {
  State
} from 'vuex-class'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from '@/components/DefaultHeaderDropdownAccnt.vue'
import SuccessModal from '@/components/Modal/Success.vue'
import ErrorModal from '@/components/Modal/Error.vue'
import { UserState } from '@/types'

@Component({
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    SuccessModal,
    ErrorModal
  }
})
export default class DefaultLayout extends Vue {
  @State user!: UserState

  // data
  nav = nav.items

  // computed
  get name () {
    return this.$route.name
  }
  get list () {
    return this.$route.matched.filter((route) => route.name || route.meta.label)
  }
}
